import { RectangleHorizontal, RectangleVertical, Square } from 'lucide-vue-next'
import { type GeneratorChoice, ImageCreativity, ImageFormat, ImageResolution, InpaintType, SubscriptionType } from '@/types'
import { i18n } from '@/i18n'

// @ts-ignore
const { t } = i18n.global

export const CGeneratorResolution: GeneratorChoice[] = [
	{
		label: () => t('generator.image_resolution.0'),
		cost: 0,
		id: ImageResolution.Standard,
		pro: false,
	},
	{
		label: () => t('generator.image_resolution.1'),
		cost: 1,
		id: ImageResolution.High,
		pro: true,
		plan: SubscriptionType.Basic,
	},
	{
		label: () => t('generator.image_resolution.2'),
		cost: 2,
		id: ImageResolution.Ultra,
		pro: true,
		plan: SubscriptionType.Pro,
	},
]

export const CGeneratorFormat: GeneratorChoice[] = [
	{
		label: () => t('generator.image_format.1'),
		cost: 0,
		id: ImageFormat.Portrait,
		icon: RectangleVertical,
		pro: false,
	},
	{
		label: () => t('generator.image_format.0'),
		cost: 0,
		id: ImageFormat.Wide,
		icon: RectangleHorizontal,
		pro: false,
	},
	{
		label: () => t('generator.image_format.2'),
		cost: 0,
		id: ImageFormat.Square,
		icon: Square,
		pro: false,
	},
]

export const CGeneratorCreativity: GeneratorChoice[] = [
	{
		label: () => t('generator.image_creativity.creative'),
		cost: 0,
		id: ImageCreativity.Creative,
		pro: false,
	},
	{
		label: () => t('generator.image_creativity.balanced'),
		cost: 0,
		id: ImageCreativity.Balanced,
		pro: false,
	},
	{
		label: () => t('generator.image_creativity.precise'),
		cost: 0,
		id: ImageCreativity.Precise,
		pro: false,
	},
]

export const CTweakActions: GeneratorChoice[] = [
	{
		label: () => t('common.tweak'),
		cost: 0,
		id: InpaintType.Tweak,
		pro: false,
	},
	{
		label: () => t('generator.add'),
		cost: 0,
		id: InpaintType.Add,
		pro: false,
	},
]
